import { render, staticRenderFns } from "./entranceTest.vue?vue&type=template&id=cbfe2476&"
import script from "./entranceTest.vue?vue&type=script&lang=js&"
export * from "./entranceTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports